module.exports = __webpack_public_path__ + "media/components/assets/icons/arrow_r-f8247f242bda8643cb61cb0eadf74ff4.svg";